import { Game } from '../game.model';

export class Finished {
  game: Game;
}
